import type { StoreApi, UseBoundStore } from 'zustand';
import { getCookie } from '@/lib/config/cookies';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

interface CountryState {
  /** Lowercase ISO 3166-1 alpha-2 country code, or null if unknown.
   *  Seeded from the `DETECTED_COUNTRY` cookie (IP-derived), then
   *  overwritten by the user's profile country when auth resolves and
   *  by the location selector when the user picks manually. */
  country: string | null;
  /** Update the current country. Pass null to clear. Inputs are
   *  lowercased before storing. */
  setCountry: (country: string | null) => void;
}

function getDetectedCountry(): string | null {
  if (typeof window === 'undefined') return null;
  const detected = getCookie('DETECTED_COUNTRY');
  if (detected !== undefined && detected.length > 0) return detected.toLowerCase();
  return null;
}

export const useCountryStore: UseBoundStore<StoreApi<CountryState>> =
  createTrackedStore<CountryState>('useCountryStore')((set) => ({
    country: getDetectedCountry(),
    setCountry: (country: string | null): void => {
      set({ country: country !== null && country.length > 0 ? country.toLowerCase() : null });
    },
  }));
